import { render } from "./IconMultistream.vue?vue&type=template&id=505d8d1a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMultistream.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "505d8d1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('505d8d1a', __exports__)) {
    api.reload('505d8d1a', __exports__)
  }
  
  module.hot.accept("./IconMultistream.vue?vue&type=template&id=505d8d1a", () => {
    api.rerender('505d8d1a', render)
  })

}


export default __exports__